import { render, staticRenderFns } from "./TableBudgetOffice.vue?vue&type=template&id=313b8f22&scoped=true"
import script from "./TableBudgetOffice.vue?vue&type=script&lang=js"
export * from "./TableBudgetOffice.vue?vue&type=script&lang=js"
import style0 from "./TableBudgetOffice.vue?vue&type=style&index=0&id=313b8f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313b8f22",
  null
  
)

export default component.exports